import { render, staticRenderFns } from "./ForgetPsw.vue?vue&type=template&id=5c1661b0&scoped=true&"
import script from "./ForgetPsw.vue?vue&type=script&lang=js&"
export * from "./ForgetPsw.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPsw.vue?vue&type=style&index=0&id=5c1661b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1661b0",
  null
  
)

export default component.exports